import { Empty, Grid } from "antd";
import type { GroupMember } from "../model/types";
import MemberItem from "./MemberItem";

const { useBreakpoint } = Grid;

interface Props {
  members: GroupMember[];
}

export default function MemberPanel({ members }: Props) {
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  return (
    <div
      style={{
        margin: isMobile ? "8px" : "16px 24px",
        border: "1px solid #E5E7EB",
        borderRadius: 8,
        padding: isMobile ? 12 : 24,
        backgroundColor: "white",
      }}
    >
      <div
        style={{
          fontWeight: 600,
          marginBottom: 24,
        }}
      >
        グループ内メンバー
      </div>

      {members.length === 0 ? (
        <Empty
          description="メンバーがいません"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      ) : (
        members.map((member) => (
          <MemberItem
            key={member.line_id}
            member={member}
            isMobile={isMobile}
          />
        ))
      )}

      {/* <Button type="link" icon={<RightOutlined />} iconPosition="end">
        すべてのメンバーを見る
      </Button> */}
    </div>
  );
}
